const UserRoles = {
    SuperAdmin: 1000,
    SystemAdmin: 2000,
    SuperUser: 3000,
    Member: 4000,
    Regional_President: 5000,
    DOperations: 6000,
    DFinance: 7000,
    PollingAgent: 8000,
}

export default UserRoles